import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
// import { Zap, LockKeyhole, MessageCircle } from "lucide-react";

export default function Landing() {
  const navigate = useNavigate();

  const messages = [
    { user: "Alex", text: "Just created a ChatMe room.", side: "left" },
    { user: "Sam", text: "Wait… no login?", side: "right" },
    { user: "Alex", text: "Nope. Just share the room ID.", side: "left" },
    { user: "Sam", text: "That's actually fast.", side: "right" },
    {
      user: "Alex",
      text: "Messages disappear when the room closes.",
      side: "left",
    },
  ];

  const cards = [
    {
      // icon: <Zap size={36} strokeWidth={2} />,
      title: "Instant Rooms",
      text: "Create chat rooms instantly and invite anyone with a room ID.",
    },
    {
      // icon: <LockKeyhole size={36} strokeWidth={2} />,
      title: "No Login",
      text: "No accounts needed. Open a room and start chatting immediately.",
    },
    {
      // icon: <MessageCircle size={36} strokeWidth={2} />,
      title: "Real-Time Chat",
      text: "Messages appear instantly using real-time socket communication.",
    },
  ];

  const [visible, setVisible] = useState(0);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible((v) => {
        if (v >= messages.length) return v;
        return v + 1;
      });
    }, 1600);
    return () => clearInterval(interval);
  }, [messages.length]);

  useEffect(() => {
    const rotate = setInterval(() => {
      setIndex((prev) => (prev + 1) % cards.length);
    }, 2500);
    return () => clearInterval(rotate);
  }, [cards.length]);

  return (
    <div className="root">
      <div className="nav">
        <div className="logo">CHATME</div>
        <button className="nav-btn" onClick={() => navigate("/home")}>
          GET STARTED
        </button>
      </div>

      <div className="hero">
        <div className="hero-left">
          <h1>
            REAL TIME CHAT <br />
            WITHOUT <span style={{ color: "#ff3c00" }}>FRICTION</span>
          </h1>
          <p>
            Create a room instantly and start chatting with anyone. No login. No
            setup. Just share the room and talk.
          </p>
          <button className="start-btn" onClick={() => navigate("/home")}>
            START CHATTING !!!
          </button>
        </div>

        <div className="editor-wrapper">
          <div className="editor-bar">
            <div className="dot red"></div>
            <div className="dot yellow"></div>
            <div className="dot green"></div>
          </div>
          <div className="editor-body">
            {messages.slice(0, visible).map((msg, i) => (
              <div
                key={i}
                className={`demo-msg ${msg.side === "right" ? "right" : ""}`}
              >
                {msg.side === "left" && (
                  <div className="demo-user">{msg.user}</div>
                )}
                <div
                  className={`demo-bubble ${
                    msg.side === "left" ? "yellow" : "green"
                  }`}
                >
                  {msg.text}
                </div>
              </div>
            ))}
            {visible < messages.length && (
              <div className="typing">
                <span></span>
                <span></span>
                <span></span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="services">
        <h2 className="services-title">OUR SERVICES</h2>
        <div className="services-stack">
          {cards.map((card, i) => {
            let position = "right";
            if (i === index) position = "center";
            else if (i === (index + 1) % cards.length) position = "right";
            else position = "left";
            return (
              <div key={i} className={`service-card ${position}`}>
                <div className="card-title-row">
                  {/* {card.icon} */}
                  <h3>{card.title}</h3>
                </div>
                <p>{card.text}</p>
              </div>
            );
          })}
        </div>
      </div>

      <div className="carousel">
        <div className="carousel-track">
          <span>REACT</span>
          <span>NODE</span>
          <span>SOCKET.IO</span>
          <span>EXPRESS</span>
          <span>REAL TIME</span>
          <span>REACT</span>
          <span>NODE</span>
          <span>SOCKET.IO</span>
          <span>EXPRESS</span>
          <span>REAL TIME</span>
          <span>REACT</span>
          <span>NODE</span>
          <span>SOCKET.IO</span>
          <span>EXPRESS</span>
          <span>REAL TIME</span>
          <span>REACT</span>
          <span>NODE</span>
          <span>SOCKET.IO</span>
          <span>EXPRESS</span>
          <span>REAL TIME</span>
          <span>REACT</span>
          <span>NODE</span>
          <span>SOCKET.IO</span>
          <span>EXPRESS</span>
          <span>REAL TIME</span>
          <span>REACT</span>
          <span>NODE</span>
          <span>SOCKET.IO</span>
          <span>EXPRESS</span>
          <span>REAL TIME</span>
        </div>
      </div>

      <style>{`

@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

*{
  margin:0;
  padding:0;
  box-sizing:border-box;
}

.root{
  font-family:'Bebas Neue',sans-serif;
  background:#f5f0e8;
  background-image:
  repeating-linear-gradient(0deg,transparent,transparent 39px,#d4c9b0 39px,#d4c9b0 40px),
  repeating-linear-gradient(90deg,transparent,transparent 39px,#d4c9b0 39px,#d4c9b0 40px);
  min-height:100vh;
  display:flex;
  flex-direction:column;
  overflow-x:hidden;
}

/* NAVBAR */
.nav{
  display:flex;
  justify-content:space-between;
  align-items:center;
  padding:8px 24px;
  border-bottom:3px solid #111;
}

.logo{
  font-size:clamp(3rem, 8vw, 4.5rem);
  color:#ff3c00;
  text-shadow:6px 6px 0px #ffd000;
}

.nav-btn{
  background:#ffbb00;
  border:3px solid #111;
  padding:10px 18px;
  font-size:clamp(0.9rem, 3vw, 1.1rem);
  box-shadow:4px 4px 0 #111;
  cursor:pointer;
  font-family:'Bebas Neue',sans-serif;
}

/* HERO */
.hero{
  display:flex;
  align-items:center;
  justify-content:space-around;
  gap:60px;
  padding:40px 30px;
  flex-wrap:wrap;
}

.hero-left h1{
  font-size:clamp(3rem, 10vw, 6rem);
  text-shadow:6px 6px 0px #ffd000;
  line-height:1;
  letter-spacing:2px;
}

.hero-left p{
  font-size:clamp(1rem, 4vw, 1.5rem);
  max-width:420px;
  margin-bottom:25px;
}

.start-btn{
  background:#2ecc71;
  border:3px solid #111;
  padding:14px 28px;
  font-size:clamp(1.2rem, 5vw, 2rem);
  box-shadow:6px 6px 0 #111;
  cursor:pointer;
  font-family:'Bebas Neue',sans-serif;
}

/* EDITOR */
.editor-wrapper{
  border:3px solid #111;
  box-shadow:10px 10px 0 #111;
  background:#f5f0e8;
  width:500px;
  height:500px;
  display:flex;
  flex-direction:column;
  flex-shrink:0;
}

.editor-bar{
  display:flex;
  gap:10px;
  padding:10px;
  border-bottom:3px solid #111;
  background:#1e1e1e;
}

.dot{
  width:12px;
  height:12px;
  border-radius:50%;
}

.red{background:#ff5f56}
.yellow{background:#ffbd2e}
.green{background:#27c93f}

.editor-body{
  padding:20px;
  overflow-y:auto;
  flex:1;
}

/* CHAT DEMO */
.demo-msg{
  display:flex;
  flex-direction:column;
  margin-bottom:10px;
}

.demo-msg.right{
  align-items:flex-end;
}

.demo-user{
  font-size:0.75rem;
  margin-bottom:3px;
}

.demo-bubble{
  border:3px solid #111;
  padding:10px 14px;
  max-width:240px;
  font-size:0.95rem;
  box-shadow:4px 4px 0 #111;
}

.yellow{background:#ffd000;}
.green{background:#b6ff00;}

/* TYPING */
.typing{
  display:flex;
  gap:5px;
  margin-top:6px;
}

.typing span{
  width:6px;
  height:6px;
  background:#111;
  border-radius:50%;
  animation:blink 1.4s infinite;
}

.typing span:nth-child(2){animation-delay:0.2s;}
.typing span:nth-child(3){animation-delay:0.4s;}

@keyframes blink{
  0%{opacity:0.2}
  20%{opacity:1}
  100%{opacity:0.2}
}

/* SERVICES */
.services{
  padding:40px 20px 100px;
  text-align:center;
}

.services-title{
  font-size:clamp(2.5rem, 8vw, 4.5rem);
  margin-bottom:20px;
  text-shadow:6px 6px 0px #ffd000;
}

.services-stack{
  position:relative;
  height:260px;
  display:flex;
  justify-content:center;
  align-items:center;
  overflow:hidden;
}

.service-card{
  position:absolute;
  width:300px;
  padding:30px;
  border:3px solid #111;
  background:#ffd000;
  transition:all 0.8s ease;
}

.service-card h3{
  font-size:1.8rem;
  margin-bottom:12px;
}

.service-card p{
  font-size:1.1rem;
}

.service-card.left{
  transform:translateX(-180px) scale(.9);
  z-index:1;
}

.service-card.center{
  transform:scale(1.1);
  z-index:3;
}

.service-card.right{
  transform:translateX(180px) scale(.9);
  z-index:2;
}

/* CAROUSEL */
.carousel{
  position:fixed;
  bottom:0;
  left:0;
  width:100%;
  border-top:3px solid #111;
  overflow:hidden;
  white-space:nowrap;
  background:#000;
  color:#fff;
  padding:12px 0;
  z-index:10;
}

.carousel-track{
  display:inline-block;
  animation:scroll 20s linear infinite;
}

.carousel span{
  margin:0 30px;
  font-size:clamp(0.9rem, 3vw, 1.2rem);
}

@keyframes scroll{
  0%{transform:translateX(0)}
  100%{transform:translateX(-50%)}
}

/* MOBILE FIX */
@media (max-width:900px){
  .hero{
    flex-direction:column;
    padding:20px;
    gap:25px;
  }

  .hero-left{
    text-align:center;
  }

  .hero-left h1{
    font-size:clamp(2.5rem, 12vw, 3.5rem);
  }

  .editor-wrapper{
    width:100%;
    height:300px;
  }

  .services-stack{
    position:relative;
    height:220px;
    overflow:hidden;
  }

  .service-card{
    position:absolute;
    width:220px;
    padding:20px;
  }

  .service-card.left{
    transform:translateX(-100px) scale(0.82);
  }

  .service-card.center{
    transform:scale(1);
    z-index:3;
  }

  .service-card.right{
    transform:translateX(100px) scale(0.82);
  }
}

`}</style>
    </div>
  );
}
